
import axios from 'axios';
import React from 'react';
import { Modal  } from 'react-bootstrap';


const OrthodonticDeleteModal = ({handleClose, showDeleteModal, selectedRowId}) => {
  
  const handleSubmit = async () => {
  
      // Send data to the backend
      const response = await axios.delete(`https://hms.backend.hiragroupcloud.com/api/orthodontic-colors/${selectedRowId}`); // Change to POST if creating a new entry
      
      
  
      // Close modal after submission
      handleClose();
  };
  
  return (
    <Modal show={showDeleteModal} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title> Orthodontic Edit Modal </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Do you really want to delete?</p>
        <div className="mb-3">
          <input
            type="hidden"
            id="modalDescription"
            className="form-control"
            name="name"
            value={selectedRowId}
          />
        </div>

      </Modal.Body>
      <Modal.Footer>
  <button
    style={{
      backgroundColor: 'red',
      // backgroundColor: '#c62828',
      border: 'none',
      color: 'white',
      cursor: 'pointer',
      padding: '10px 15px',
      fontSize: '16px',
      marginLeft: '10px',
    }} 
    onClick={handleSubmit}
  >
    Delete
  </button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrthodonticDeleteModal;
